import React, { useMemo } from 'react';
import useComponentVisible from '../../../../helpers/hooks/useComponentVisible';
import './css/index.scss';

function pluralRuItems(count) {
  const n = Number(count);
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} пункт`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${n} пункта`;
  return `${n} пунктов`;
}

function EventsCheckboxDropdown({
  label,
  options,
  selectedIds,
  onToggle,
  getOptionLabel = (option) => option.name,
  getOptionId = (option) => option.id,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const summary = useMemo(() => {
    if (!options.length) return 'Нет данных';
    if (!selectedIds.length || selectedIds.length === options.length) return 'Все';
    if (selectedIds.length > 2) return `Выбрано ${pluralRuItems(selectedIds.length)}`;
    return options
      .filter((option) => selectedIds.includes(getOptionId(option)))
      .map((option) => getOptionLabel(option))
      .join(', ');
  }, [options, selectedIds, getOptionId, getOptionLabel]);

  const onTriggerClick = (e) => {
    e.stopPropagation();
    setIsComponentVisible((value) => !value);
  };

  return (
    <div className="events_checkbox_dropdown" ref={ref}>
      <span className="events_checkbox_dropdown_label">{label}</span>
      <button
        type="button"
        className="events_checkbox_dropdown_trigger"
        onClick={onTriggerClick}
      >
        {summary}
      </button>
      {isComponentVisible ? (
        <div
          className="events_checkbox_dropdown_panel"
          role="listbox"
          onClick={(e) => e.stopPropagation()}
        >
          {options.map((option) => {
            const id = getOptionId(option);
            return (
              <label key={id} className="events_checkbox_dropdown_row">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(id)}
                  onChange={() => onToggle(id)}
                />
                <span>{getOptionLabel(option)}</span>
              </label>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

export default EventsCheckboxDropdown;
